export default __webpack_public_path__ + "static/1383-fd34f7e4ef0bc0d63ef1483630d934a9.gif";